// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3d6OZ","col":"styles_col__7tz11"};